// Fincan + değirmen sensörü hassasiyeti (1-10) ve eşik tablosu.
// Sözleşme v1.1: BayinerIOT-Workspace- docs/api-contracts/
// cup-grinder-sensor-live.md → "Hassasiyet" tablosu ve §4b Ayarlar (#132).
// Tablo kartın firmware'indeki tabloyla birebir aynıdır; yük `threshold`
// taşımıyorsa (eski tablet) eşik buradan hesaplanır.

import {
  DEFAULT_CUP_THRESHOLD,
  DEFAULT_GRINDER_THRESHOLD,
} from "./cupGrinderSensorHistory";

export const MIN_SENSITIVITY = 1;
export const MAX_SENSITIVITY = 10;
export const DEFAULT_SENSITIVITY = 5;

/** Hassasiyet 1..10 → eşik (dizin = hassasiyet - 1). */
export const CUP_THRESHOLDS = [
  -450, -380, -320, -280, -250, -220, -190, -160, -130, -100,
];
export const GRINDER_THRESHOLDS = [
  -198, -167, -141, -123, -110, -97, -84, -70, -57, -44,
];

const TABLES = { cup: CUP_THRESHOLDS, grinder: GRINDER_THRESHOLDS };
const DEFAULTS = {
  cup: DEFAULT_CUP_THRESHOLD,
  grinder: DEFAULT_GRINDER_THRESHOLD,
};

const isNum = (v) => typeof v === "number" && Number.isFinite(v);
const isValidSensitivity = (v) =>
  Number.isInteger(v) && v >= MIN_SENSITIVITY && v <= MAX_SENSITIVITY;

/** Sensörün hassasiyeti (yükte yoksa / geçersizse fabrika değeri 5). */
export const sensitivityOf = (sensor) =>
  isValidSensitivity(sensor?.sensitivity)
    ? sensor.sensitivity
    : DEFAULT_SENSITIVITY;

/** Hassasiyetin eşik değeri (tablodan). */
export const thresholdForSensitivity = (kind, sensitivity) =>
  isValidSensitivity(sensitivity)
    ? TABLES[kind][sensitivity - 1]
    : DEFAULTS[kind];

/**
 * Sensörün eşiği: yükteki `threshold` → hassasiyet tablosu → v1.0 yükündeki
 * ortak eşik (`fallback`, ör. cupThreshold) → varsayılan (-250 / -110).
 */
export const thresholdOf = (kind, sensor, fallback) => {
  if (isNum(sensor?.threshold)) return sensor.threshold;
  if (isValidSensitivity(sensor?.sensitivity))
    return TABLES[kind][sensor.sensitivity - 1];
  if (isNum(fallback)) return fallback;
  return DEFAULTS[kind];
};

/** Hassasiyet tablosu (açıklama paneli için). */
export const thresholdTable = (kind) =>
  TABLES[kind].map((threshold, i) => ({ sensitivity: i + 1, threshold }));

/**
 * Hassasiyet yazma değişikliği (settings/WRITE, §4b).
 * Fincan: custom/turkishCoffee, göz başına. Değirmen: genel Türk kahvesi
 * ayarlarıyla aynı biçim — group "general.turkishCoffee" (GeneralSection,
 * makinede VALID_GENERAL_GROUPS); rol şablonu yolu
 * `general.turkishCoffee.grinderSensorSensitivity`.
 */
export const buildSensitivityChange = (kind, cup, value) =>
  kind === "cup"
    ? {
        group: "custom",
        potIndex: cup,
        type: "TC",
        subgroup: "turkishCoffee",
        key: "cupSensorSensitivity",
        value,
      }
    : {
        group: "general.turkishCoffee",
        key: "grinderSensorSensitivity",
        value,
      };
